export const customerServiceEmail = 'backoffice@fleequid.com';
